<template>
  <el-dialog
    title="對講機 APP 授權名單："
    :visible="isDialogVisible"
    class="editAuthorizedDialog"
    :show-close="!isOverAuthorizedSave"
    :close-on-click-modal="!isOverAuthorizedSave"
    :close-on-press-escape="!isOverAuthorizedSave"
    width="50%"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <h2 class="el-dialog__title">
      社區已授權戶數：
      <span :class="isOverAuthorizedNoSave?'dangerColor-text':'mainColor-text'">
        {{ authorizedHousehold.length }}
      </span>
      /{{ authorizedTabletsTotalNum }}
    </h2>
    <ul>
      <li>經授權的戶別，才可透過對講機App進行撥打與接聽來電</li>
      <li>未經授權的戶別，住戶可下載並開通對講機App，但將無法顯示通訊錄，且無法進行撥打或接聽</li>
    </ul>

    <p>點擊欲授權之戶別（僅顯示區權戶）</p>
    <div class="household-filter">
      <el-select
        v-model="chosenTower"
        class="household-select"
        placeholder="請選擇棟別"
      >
        <el-option
          v-for="tower in towerData"
          :key="tower.Tag"
          :label="tower.Tag"
          :value="tower.Tag"
        />
      </el-select>
      <el-select
        v-model="chosenFloor"
        class="household-select"
        placeholder="請選擇樓層"
        :disabled="!chosenTower"
      >
        <el-option
          v-for="floor in floorData"
          :key="floor.Floor"
          :label="$t('Household.Floor', {floor: floor.Floor})"
          :value="floor.Floor"
        />
      </el-select>
      <el-select
        v-model="chosenHousehold"
        class="household-select"
        multiple
        collapse-tags
        placeholder="請選擇戶別"
        :disabled="!chosenFloor"
      >
        <el-option
          :label="'全選'"
          :value="'all'"
          :disabled="isDisabledAllTabletOption"
        />
        <el-option
          v-for="tablet in tabletData"
          :key="tablet.TabletId"
          :label="tablet.TabletNote"
          :value="tablet.TabletId"
          :disabled="isDisabledAuthorizedSelect(tablet.TabletId) || chosenHousehold.includes('all')"
        />
      </el-select>
      <el-button
        :disabled="isOverOrEqualAuthorized || !chosenHousehold.length"
        icon="icon-plus"
        round
        @click="addHousehold"
      >
        新增
      </el-button>
    </div>
    <div class="household-tags-content">
      <template v-if="!authorizedHousehold.length">
        <div class="no-household-content">
          <div>
            未選擇任何戶別
          </div>
        </div>
      </template>
      <template v-else>
        <template>
          <el-tag
            v-for="household in authorizedHousehold"
            :key="household.TabletId"
            closable
            :disable-transitions="true"
            @close="deleteHousehold(household)"
          >
            {{ household.TabletNote }}
          </el-tag>
        </template>
      </template>
    </div>
    <span slot="footer">
      <el-button
        type="danger"
        round
        @click="clearAuthorizedDialog"
      >清除全部</el-button>
      <el-button
        v-if="!isOverAuthorizedSave"
        round
        @click="dialogClose"
      >取消</el-button>
      <el-button
        type="primary"
        round
        @click="putAuthorizedTablets"
      >儲存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      isDialogVisible: false,
      towerData: [],
      floorData: [],
      tabletData: [],
      chosenTower: '',
      chosenFloor: '',
      chosenHousehold: [], // 目前在select選單上的戶別
      authorizedHousehold: [], // 已被加進列表中的戶別
      originAuthorizedHousehold: [] // 存一份初始資料，離開時才知道資料是否被更改
    }
  },
  computed: {
    ...mapState('intercom', ['authorizedTabletsTotalNum']),
    isOverAuthorizedNoSave () {
      // 給尚未儲存的判定使用，例如現在新增已超過上限
      if (!this.authorizedHousehold || !this.authorizedTabletsTotalNum) { return false }

      return this.authorizedHousehold.length > this.authorizedTabletsTotalNum
    },
    isOverAuthorizedSave () {
      // 給需要儲存後的判定，例如取消鍵是否顯示
      if (!this.originAuthorizedHousehold || !this.authorizedTabletsTotalNum) { return false }

      return this.originAuthorizedHousehold.length > this.authorizedTabletsTotalNum
    },
    isOverOrEqualAuthorized () {
      if (!this.authorizedHousehold || !this.authorizedTabletsTotalNum) { return false }

      return this.authorizedHousehold.length >= this.authorizedTabletsTotalNum
    },
    authorizeColor () {
      if (this.authorizedHousehold.length > this.authorizedTabletsTotalNum) { return 'dangerColor-text' } else { return 'mainColor-text' }
    },
    isDisabledAllTabletOption () {
      const isDisabled = this.tabletData.every((item) => {
        // eslint-disable-next-line eqeqeq
        const isChosen = this.authorizedHousehold.find((x) => x.TabletId == item.TabletId)
        return isChosen
      })
      return isDisabled
    }
  },
  watch: {
    '$store.state.intercom.isOpenAuthorizedDialog': {
      handler: function (newVal, oldVal) {
        // 外部可以開啟dialog，但關閉僅由內部控制
        if (newVal) { this.isDialogVisible = newVal }
      }
    },
    chosenTower: {
      handler: async function () {
        // eslint-disable-next-line eqeqeq
        if (this.chosenTower != '') {
          await this.getFloors()
          this.chosenFloor = ''
          this.chosenHousehold = []
        }
      }
    },
    chosenFloor: {
      handler: async function () {
        // eslint-disable-next-line eqeqeq
        if (this.chosenFloor != '') {
          await this.getTablets()
          this.chosenHousehold = []
        }
      }
    },
    chosenHousehold: {
      handler: function (n, o) {
        // eslint-disable-next-line eqeqeq
        if ((!o.includes('all') && n.includes('all')) || (this.chosenHousehold.length == this.tabletData.length && this.chosenHousehold.length > 0 && !this.chosenHousehold.includes('all'))) {
          this.chosenHousehold = ['all']
        }
      }
    }

  },
  methods: {
    dialogOpen () {
      this.getAuthorizedTablets()
      this.getTags()
    },
    async getTags () {
      try {
        const res = await apiIntercom.Community.GetTags()
        this.towerData = res.data.Data.Tags
      } catch (err) {
        console.log(err)
      }
    },
    async getFloors () {
      try {
        const res = await apiIntercom.Community.GetFloors(this.chosenTower)
        this.floorData = res.data.Data.Floors
      } catch (err) {
        console.log(err)
      }
    },
    async getTablets () {
      try {
        const res = await apiIntercom.Community.GetTablets(this.chosenTower, this.chosenFloor)
        this.tabletData = res.data.Data.Tablets.filter(el => el.IsVirtual === '0')
      } catch (err) {
        console.log(err)
      }
    },
    /**
     * 部分銷售合約:
     * 1. 檢查已授權戶數是否超過社區可使用戶數
     */
    async checkAuthorizedTablets () {
      const partialSaleData = this.$store.getters['intercom/partialSaleContract']
      if (partialSaleData) {
        // 如果已授權戶數超越可使用戶數，則不必任何觸發就強制跳出此dialog
        if (!this.isDialogVisible && partialSaleData.CurrentNumberOfAuthorizedTablets > this.authorizedTabletsTotalNum) {
          this.isDialogVisible = true
          this.$alert('目前已授權使用的戶數已超過社區購買的可用戶數，請修改使用授權名單', '請修改使用授權名單', {
            confirmButtonText: '確認',
            type: 'warning',
            callback: action => {}
          })
          this.$store.commit('intercom/triggerAuthorizedDialog', true)
        }
      }
    },
    // 新增使用授權名單
    addHousehold () {
      if (this.chosenHousehold.includes('all')) {
        this.tabletData.forEach((item) => {
          // eslint-disable-next-line eqeqeq
          const isChosen = this.authorizedHousehold.find((x) => x.TabletId == item.TabletId)
          if (!isChosen) {
            this.authorizedHousehold.push(item)
          }
        })
      } else {
        this.chosenHousehold.forEach((item) => {
          // eslint-disable-next-line eqeqeq
          const household = this.tabletData.find((x) => x.TabletId == item)
          // eslint-disable-next-line eqeqeq
          const isChosen = this.authorizedHousehold.find((x) => x.TabletId == item)

          if (household && !isChosen) { this.authorizedHousehold.push(household) }
        })
      }
      this.chosenTower = ''
      this.chosenFloor = ''
      this.chosenHousehold = []
    },
    // 刪除使用授權名單其中一戶
    deleteHousehold (household) {
      // eslint-disable-next-line eqeqeq
      const index = this.authorizedHousehold.findIndex((x) => x.TabletId == household.TabletId)
      if (index > -1) this.authorizedHousehold.splice(index, 1)
    },
    // select選單禁止掉已有選項
    isDisabledAuthorizedSelect (id) {
      return !!this.authorizedHousehold.find((el) => el.TabletId === id)
    },
    clearAuthorizedDialog () {
      this.chosenHousehold = []
      this.authorizedHousehold = []
    },
    // 取得已授權戶
    async getAuthorizedTablets () {
      try {
        const res = await apiIntercom.Sentry.GetAuthorizedTablets()
        this.authorizedHousehold = res.data.Data.Tablets

        this.originAuthorizedHousehold = _cloneDeep(this.authorizedHousehold)
      } catch (err) {
        console.log(err)
      }
    },
    // 設定授權戶
    async putAuthorizedTablets () {
      if (this.isOverAuthorizedNoSave) {
        this.$message({
          message: '已授權戶數超過社區可用戶數，請修改後再試',
          type: 'warning'
        })
        return
      }

      if (_isEqual(this.originAuthorizedHousehold, this.authorizedHousehold)) {
        // 資料沒變就不打api，減少api壓力
        this.$message({
          message: '名單已更新',
          type: 'success'
        })
        return
      }

      try {
        const data = { TabletIds: [] }
        this.authorizedHousehold.forEach((el) => {
          data.TabletIds.push(el.TabletId)
        })
        await apiIntercom.Sentry.PutAuthorizedTablets(data)
        this.$message({
          message: '名單已更新',
          type: 'success'
        })
        this.originAuthorizedHousehold = _cloneDeep(this.authorizedHousehold)
      } catch (e) {
        console.log(e)
      }
    },
    dialogClose () {
      // 理論上可用:before-close實作此需求，但before-close不知為何一直被不預期的呼叫
      // 因此採用@close實作此需求，透過手動控制isDialogVisible去控開關
      this.isDialogVisible = true
      this.chosenTower = ''
      this.chosenFloor = ''
      this.chosenHousehold = []
      if (_isEqual(this.originAuthorizedHousehold, this.authorizedHousehold)) {
        this.$store.commit('intercom/triggerAuthorizedDialog', false)
        this.isDialogVisible = false
        return
      }

      this.$confirm('若直接離開，您的異動資料將不會儲存', '尚未儲存', {
        confirmButtonText: '離開',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: '取消',
        closeOnClickModal: false
      }).then(action => {
        this.$store.commit('intercom/triggerAuthorizedDialog', false)
        this.isDialogVisible = false
        this.authorizedHousehold = _cloneDeep(this.originAuthorizedHousehold)
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
  .editAuthorizedDialog {
    ::v-deep .el-dialog {
      @include basicDialog;
      ul {
        list-style-position: inside;
        li {
          list-style-type: disc;
          margin-left: 40px;
        }
      }
      p {
        margin-top: 2rem;
        margin-bottom: 0.5rem;
      }
      .household-filter {
        display: flex;
      }
      .household-select {
        padding-right: 5px;
      }
      .household-tags-content {
        padding-block: 20px;
        min-height: 200px;
        max-height: 35vh;
        overflow-y: auto;
        .el-tag {
          margin-right: 3px;
          margin-top: 3px;
        }
      }
      .no-household-content {
        padding-block: 20px;
        text-align: center;
        font-weight: bold;
      }
      .el-dialog__footer {
        text-align: center
      }

    }
  }
  .mainColor-text {
    color: $mainColor;
  }
  .dangerColor-text {
    color: $dangerColor;
  }
</style>
